import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';

import Notification from './Notification';

import { primaryColor } from '~theme';

import trashSVG from '~images/trashbin.svg';

const Notifications = () => {
  const [editing, setEditing] = useState(false);
  const notifications = useSelector(state => state.user.notifications);
  const unreadCount = notifications?.filter(n => !n.seen).length;

  return (
    <Wrapper>
      <Header>
        <UnreadCount>Lukemattomia {unreadCount} kpl</UnreadCount>
        <Edit onClick={() => setEditing(!editing)}>
          {editing ? 'Lopeta muokkaus' : 'Muokkaa'} <TrashIcon src={trashSVG} />
        </Edit>
      </Header>
      <NotificationArea>
        {notifications?.map(notification => (
          <Notification
            key={notification.id}
            notification={notification}
            editing={editing}
          />
        ))}
      </NotificationArea>
      <Disclaimer>
        Ilmoitukset häviävät viikon kuluttua ilmestymisestään.
      </Disclaimer>
    </Wrapper>
  );
};

const Wrapper = styled.div``;

const NotificationArea = styled(SimpleBar)`
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  margin: 0 -24px;
  background-color: white;

  max-height: 350px;

  // Scrollbar stuff
  .simplebar-track.simplebar-vertical {
    width: 18px;
    background-color: ${primaryColor};
    border-left: 1px solid white;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .simplebar-scrollbar::before {
    background-color: white;
    opacity: 255;
    left: 4px;
    right: 4px;
  }

  .simplebar-track.simplebar-vertical .simplebar-scrollbar::before {
    top: 4px;
    bottom: 4px;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  margin-bottom: 12px;
  font-size: 12px;
`;

const UnreadCount = styled.div``;

const Edit = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  & > img {
    margin-left: 12px;
  }
`;

const TrashIcon = styled.img`
  width: 16px;
`;

const Disclaimer = styled.div`
  font-size: 12px;
  margin-top: 22px;
  color: white;
`;

export default Notifications;
